import React, { useState, useEffect, useContext } from 'react'
import { useParams, Redirect } from 'react-router-dom'
import { Message } from 'primereact/message'
import { CoursesForm } from '../../components/CoursesForm'
import { Layout } from '../../components/Layout'
import { CoursesService } from '../../services/Courses'
import { Context } from '../../Context'
import { GLOBALS } from '../../utils/Globals'
import { UserService } from '../../services/User'
import { LaboratoryService } from '../../services/Laboratory'

import './styles.scss'

export const CreateEditCourses = () => {

  const { id: idToEdit } = useParams();
  const { isAuth: token, userLogged } = useContext(Context);

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [redirectTo, setRedirectTo] = useState(null);

  const [CourseToEdit, setCourseToEdit] = useState([]);
  const [usersList, setUsersList] = useState([])
  const [usersListToEdit, setUsersListToEdit] = useState([])
  const [usersListE, setUsersListE] = useState([])
  const [usersListEToEdit, setUsersListEToEdit] = useState([])
  const [laboratoriesList, setLaboratoriesList] = useState([])
  const [laboratoriesListToEdit, setlaboratoriesListToEdit] = useState([])

  const config = {
    title: 'Crear Curso',
    icon: GLOBALS.menu.courses.icon,
    link: GLOBALS.menu.courses.link,
    linkList: GLOBALS.menu.courses.linkList,
  }

  if (idToEdit) {
    config.title = 'Editar Cursos'
  }

  const fetchData = async () => {
    try {
      setIsLoading(true)
      const [course, usersList, usersListToEdit, usersListE, usersListEToEdit, laboratoriesList, laboratoriesListToEdit] = await Promise.all([
        (async () => {
          if (idToEdit) {
            const courseToEdit = await CoursesService.getById(idToEdit, token);
            return courseToEdit;
          }
          return null
        })(),
        UserService.getAll(token, { role: GLOBALS.roles.teacher.id }),
        UserService.getcoursesxUserById(idToEdit, token),
        UserService.getAll(token, { role: GLOBALS.roles.student.id }),
        UserService.getcoursesxUserEById(idToEdit, token),
        LaboratoryService.getLaboratoriesxcourse(token),
        (async () => {
          if (idToEdit) {
            const courseToEdit = await CoursesService.getById(idToEdit, token);
            return courseToEdit;
          }
          return null
        })()
      ])

      setCourseToEdit(course)
      setUsersListE(usersListE.map((u) => {
        return {
          label: `${u.name} - ${u.email}`,
          value: u.id,
        }
      }))

      setUsersListEToEdit(
        usersListEToEdit.map((u) => {
          return {
            label: `${u.name}`,
            value: u.id,
          }
        })
      )

      if (idToEdit) {
        
        if (laboratoriesListToEdit) {
          setlaboratoriesListToEdit(
            laboratoriesListToEdit.laboratories.map((u) => {
              return {
                label: `${u.name}`,
                value: u.id,
              }
            })
          )
        }
      }

      setLaboratoriesList(
        laboratoriesList.map((u) => {
          return {
            label: `${u.name}`,
            value: u.id,
          }
        })
      )

      setUsersList(
        usersList.map((u) => {
          return {
            label: `${u.name} - ${u.email}`,
            value: u.id,
          }
        })
      )

      setUsersListToEdit(
        usersListToEdit.map((u) => {
          return {
            label: `${u.name} - ${u.email} - ${u.role}`,
            value: u.id,
          }
        })
      )

    } catch (e) {
      setError(e.message)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const onSubmit = async (data) => {
    try {
      setIsLoading(true)

      if (idToEdit) {
        await CoursesService.update(idToEdit, data, token)
      } else {
        await CoursesService.create(data, token)
      }

      setIsLoading(false)
      setError(null)

      setRedirectTo({
        pathname: config.linkList,
        state: { success: true },
      })
    } catch (e) {
      setIsLoading(false)
      setError(e.message)
    }
  }

  if (redirectTo) {
    return <Redirect to={redirectTo} />
  }


  return (
    <Layout>
      {isLoading || (!CourseToEdit && idToEdit) ? (
          <div className="loading-container">
          <i className="pi pi-spin pi-spinner" style={{ fontSize: '4em' }}></i>
        </div>
      ) : error ? (
        <Message severity="error" text={"error"}></Message>
      ) : (
        <div className="p-fluid">
          <div className="p-grid">
            <div className="p-col-12">
              <div className="card card-w-title">
                <h1 className="create-edit-title">
                  {config.icon && <i className={config.icon}></i>}
                  {config.title}
                </h1>

                <CoursesForm
                  item={CourseToEdit}
                  isLoading={isLoading}
                  usersList={usersList}
                  usersListToEdit={usersListToEdit}
                  usersListE={usersListE}
                  usersListEToEdit={usersListEToEdit}
                  laboratoryList={laboratoriesList}
                  laboratoriesListToEdit={laboratoriesListToEdit}
                  onSubmit={onSubmit}
                  cancelLink={config.linkList}
                  userLogged={userLogged.role}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </Layout>
  )
}